/*
 * @Author: Peng Bo Wei
 * @Date: 2021-10-25 18:40:53
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-10 10:36:31
 * @Description: 
 */
export default {
  state: {
    reportData: {},
    reportFillType: "",
    fundIdList: [],
    institutionCode:"",

  },
  mutations: {
    setReportData(state, data) {
      console.log("setReportData", data)
      if (typeof data.value != 'undefined') {
        state.reportData[data.codeId] = data.value;
      }
      if (typeof data.reportFillType != 'undefined') {
        state.reportFillType = data.reportFillType;
      }
      if (typeof data.institutionCode != 'undefined') {
        state.institutionCode = data.institutionCode;
      }
      if (typeof data.fundIdList != 'undefined') {
        state.fundIdList = data.fundIdList;
      }
    }
  }
}